// Anchor links shown in the marketing nav; each points at a section id on the page.
export type NavLink = {
    label: string;
    href: string;
};

export const NAV_LINKS: NavLink[] = [
    { label: "Home", href: "#home" },
    { label: "Features", href: "#features" },
    { label: "Showcase", href: "#showcase" },
    { label: "How it works", href: "#how-it-works" },
    { label: "Pricing", href: "#pricing" },
];
